<div class="bet-container">
    <div class="wrapper">
        <div class="title">Bet Sizing</div>
        <div class="bet-buttons">
            <app-sopo-select-button
            title="Bet Size"
            [selectedText]=" betSizes.bet1 + ' Pot'"
            [list]="getBetSizingArray(betSizes.bet1)"
            listText="Pot"
            [selected]="betSizes.bet1"
            (selectedChange)="selectChangedBet($event, 'bet1')"
            [showIcon]="false"
            [zIndex]="zIndex">
            </app-sopo-select-button>
            <app-sopo-select-button
            title="Bet Size"
            [selectedText]=" betSizes.bet2 + ' Pot'"
            [list]="getBetSizingArray(betSizes.bet2)"
            listText="Pot"
            [selected]="betSizes.bet2"
            (selectedChange)="selectChangedBet($event, 'bet2')"
            [showIcon]="false"
            [zIndex]="zIndex">
            </app-sopo-select-button>
            <app-sopo-select-button
            title="Bet Size"
            [selectedText]=" betSizes.bet3 + ' Pot'"
            [list]="getBetSizingArray(betSizes.bet3)"
            listText="Pot"
            [selected]="betSizes.bet3"
            (selectedChange)="selectChangedBet($event, 'bet3')"
            [showIcon]="false"
            [zIndex]="zIndex">
            </app-sopo-select-button>
        </div>
    </div>
    <div class="wrapper">
        <div class="title">Raise Sizing</div>
        <div class="bet-buttons">
            <app-sopo-select-button
            title="Raise Size"
            [selectedText]=" raiseSizes.raise1 + ' Pot'"
            [list]="getRaiseSizingArray(raiseSizes.raise1)"
            listText="Pot"
            [selected]="raiseSizes.raise1"
            (selectedChange)="selectChangedRaise($event, 'raise1')"
            [showIcon]="false"
            [zIndex]="zIndex">
            </app-sopo-select-button>
            <app-sopo-select-button
            title="Raise Size"
            [selectedText]=" raiseSizes.raise2 + ' Pot'"
            [list]="getRaiseSizingArray(raiseSizes.raise2)"
            listText="Pot"
            [selected]="raiseSizes.raise2"
            (selectedChange)="selectChangedRaise($event, 'raise2')"
            [showIcon]="false"
            [zIndex]="zIndex">
            </app-sopo-select-button>
            <app-sopo-select-button
            title="Raise Size"
            [selectedText]=" raiseSizes.raise3 + ' Pot'"
            [list]="getRaiseSizingArray(raiseSizes.raise3)"
            listText="Pot"
            [selected]="raiseSizes.raise3"
            (selectedChange)="selectChangedRaise($event, 'raise3')"
            [showIcon]="false"
            [zIndex]="zIndex">
            </app-sopo-select-button>
        </div>
    </div>
</div>